import { render, staticRenderFns } from "./AboutAsComponent.vue?vue&type=template&id=5a2c4368&scoped=true&"
import script from "./AboutAsComponent.vue?vue&type=script&lang=js&"
export * from "./AboutAsComponent.vue?vue&type=script&lang=js&"
import style0 from "./AboutAsComponent.vue?vue&type=style&index=0&id=5a2c4368&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2c4368",
  null
  
)

export default component.exports